import Vue from "vue";
import "@/default/pages/containers/shared/shared.js";

import OrderStatusId from "./id.vue";
import OrderStatusAction from "./action.vue";
import OrderStatusSsline from "./ssline.vue";
import OrderStatusWarehouseName from "./warehouse-name.vue";
import OrderStatusWarehouseCity from "./warehouse-city.vue";
import OrderStatusWarehouseState from "./warehouse-state.vue";
import OrderStatusContNo from "./cont-no.vue";
import OrderStatusChassisNo from "./chassis-no.vue";
import OrderStatusTerminals from "./terminals.vue";
import OrderStatusYards from "./yards.vue";
import OrderStatusYardContainer from "./yard-container.vue";
import OrderStatusYardChassis from "./yard-chassis.vue";
import OrderStatusReturnInstructions from "./return-instructions.vue";
import OrderStatusYardDays from "./yard-days.vue";
import OrderStatusYardStatus from "./yard-status.vue";
import OrderStatusTruckers from "./truckers.vue";
import OrderStatusNotifiedAt from "./notified-at.vue";
import OrderStatusEta from "./eta.vue";
import OrderStatusLfd from "./lfd.vue";
import OrderStatusPerDiemLfd from "./per-diem-lfd.vue";
import OrderStatusErd from "./erd.vue";
import OrderStatusCod from "./cod.vue";
import OrderStatusDispatchComment from "./dispatch-comment.vue";
import OrderStatusTasks from "./tasks.vue";
import OrderStatusRouteAppt from "./route-appt.vue";

Vue.component("order-status-id", OrderStatusId);
Vue.component("order-status-action", OrderStatusAction);
Vue.component("order-status-ssline", OrderStatusSsline);
Vue.component("order-status-warehouse-name", OrderStatusWarehouseName);
Vue.component("order-status-warehouse-city", OrderStatusWarehouseCity);
Vue.component("order-status-warehouse-state", OrderStatusWarehouseState);
Vue.component("order-status-cont-no", OrderStatusContNo);
Vue.component("order-status-chassis-no", OrderStatusChassisNo);
Vue.component("order-status-terminals", OrderStatusTerminals);
Vue.component("order-status-yards", OrderStatusYards);
Vue.component("order-status-yard-container", OrderStatusYardContainer);
Vue.component("order-status-yard-chassis", OrderStatusYardChassis);
Vue.component(
  "order-status-return-instructions",
  OrderStatusReturnInstructions,
);
Vue.component("order-status-yard-days", OrderStatusYardDays);
Vue.component("order-status-yard-status", OrderStatusYardStatus);
Vue.component("order-status-truckers", OrderStatusTruckers);
Vue.component("order-status-notified-at", OrderStatusNotifiedAt);
Vue.component("order-status-eta", OrderStatusEta);
Vue.component("order-status-lfd", OrderStatusLfd);
Vue.component("order-status-per-diem-lfd", OrderStatusPerDiemLfd);
Vue.component("order-status-erd", OrderStatusErd);
Vue.component("order-status-cod", OrderStatusCod);
Vue.component("order-status-dispatch-comment", OrderStatusDispatchComment);
Vue.component("order-status-tasks", OrderStatusTasks);
Vue.component("order-status-route-appt", OrderStatusRouteAppt);
